import React, { memo } from 'react';
import type { LocalizedLabel } from '@segmently/schema-models/v2';
import type { TemplateVariables } from '../../../utils/contentResolver';
import { Text } from '../Text';

export interface OptionsItemTextProps {
  label: LocalizedLabel | undefined;
  locale: string;
  variables?: TemplateVariables;
  className?: string;
  editPath?: string;
}

export const OptionsItemText = memo(function OptionsItemText({
  label,
  locale,
  variables,
  className,
  editPath,
}: OptionsItemTextProps): React.ReactElement | null {
  if (!label) {
    return null;
  }

  return (
    <Text
      label={label}
      locale={locale}
      variables={variables}
      className={className}
      editPath={editPath}
    />
  );
});

OptionsItemText.displayName = 'OptionsItemText';
